export default __webpack_public_path__ + "static/media/analisis.8eb5608e.PNG";